export const LOCALHOST = 'localhost';

export const is = {
  localhost: window.location.hostname.includes(LOCALHOST),
  validDate: (value: unknown): value is Date =>
    value instanceof Date && value.toString() !== 'Invalid Date',
  null: (value: unknown): value is null => value === null,
  undefined: (value: unknown): value is undefined =>
    typeof value === 'undefined' || value === undefined,
  nullOrUndefined: (value: unknown): value is null | undefined =>
    is.null(value) || is.undefined(value),
  truthy: (value: unknown): value is true => !!value,
  falsy: (value: unknown): value is false => !value,
  false: (value: unknown): value is false => value === false,
  string: (value: unknown): value is string => typeof value === 'string',
  number: (value: unknown): value is number => typeof value === 'number',
  boolean: (value: unknown): value is boolean => typeof value === 'boolean',
  date: (value: unknown): value is Date => value instanceof Date,
  object: (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object',
  array: <T>(value: unknown): value is T[] => Array.isArray(value),
  empty: (value: unknown): boolean => {
    if (is.nullOrUndefined(value)) {
      return true;
    }

    if (Array.isArray(value) || is.string(value)) {
      return value.length === 0;
    }

    if (is.date(value)) {
      return !isValidDate(value);
    }

    return is.object(value) && Object.keys(value).length === 0;
  },
};

export function isInvalidDate(date: Date) {
  return String(date) == 'Invalid Date';
}

export function isValidDate(date: Date): boolean {
  return String(date) !== 'Invalid Date';
}
